module.exports = __webpack_public_path__ + "img/back-icon1.8ceab760.png";